import React from 'react';
import {createRoot} from 'react-dom/client';
import {KatSpinner} from '@amzn/katal-react';

import {App} from './app/App';
import {AppInitWrapper} from './app/AppInitWrapper';

import '@amzn/katal-components/styles.css';
import './theming/styles/bodegaTheme.scss';
import './theming/styles/base.scss';
import {installAbortSignalPolyfill} from 'abort-signal-polyfill';
import {NuqsAdapter} from 'nuqs/adapters/react';

// Polyfill AbortSignal.timeout. This needs a separate polyfill because corejs
// does not include one.
installAbortSignalPolyfill();

const container = document.getElementById('root');
const root = createRoot(container!);
root.render(
  <React.StrictMode>
    <NuqsAdapter>
      <AppInitWrapper>
        <React.Suspense fallback={<KatSpinner size="large" />}>
          <App />
        </React.Suspense>
      </AppInitWrapper>
    </NuqsAdapter>
  </React.StrictMode>,
);
